// extracted by mini-css-extract-plugin
module.exports = {"blog-container":"Blog_blog-container__2wdLL","blog-content":"Blog_blog-content__3rrVs","img-container":"Blog_img-container__-NEIl","pre-content":"Blog_pre-content__1v02c"};